import classNames from 'classnames';
import styles from './header.module.scss';
import ChatEmptyProfileImage from '../../../assets/image/shared/chat_empty_profile_image.svg';
import {useNavigate} from 'react-router-dom';
import {Dropdown} from 'react-bootstrap';
import React from 'react';
import ViolationIcon from '../../../assets/image/violation/error.svg';

type TMessageHeaderProps = {
  title: string;
  setOpenViolationModal: React.Dispatch<React.SetStateAction<boolean>>;
};
type CustomToggleProps = {
  children: React.ReactNode;
  onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};
const CustomToggle = React.forwardRef(
  (props: CustomToggleProps, ref: React.Ref<HTMLAnchorElement>) => (
    <div>
      <i
        className="icon-setting-chats color-gray-1 pt-1"
        ref={ref}
        onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
          e.stopPropagation();
          props?.onClick(e);
        }}
      >
        {props.children}
      </i>
    </div>
  ),
);
const MessageHeader = ({title, setOpenViolationModal}: TMessageHeaderProps) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className={classNames(
          styles['header'],
          'd-flex justify-content-between',
        )}
      >
        <div className={classNames('d-flex align-items-center px-3')}>
          <i
            className="icon-arrow-right1 color-gray-1"
            onClick={() => navigate(-1)}
          ></i>
          <img src={ChatEmptyProfileImage} alt="" className="mx-2" />
          <span className="color-gray-1">{title}</span>
        </div>
        <div className=" mt-3">
          <Dropdown>
            <Dropdown.Toggle as={CustomToggle} />
            <Dropdown.Menu title="">
              <Dropdown.Item>
                <div
                  className="text-end w-100 d-flex align-items-center"
                  onClick={() => setOpenViolationModal(true)}
                >
                  <img
                    src={ViolationIcon}
                    className={classNames(
                      styles['violation-icon'],
                      'color-primary ps-1',
                    )}
                    alt="violation"
                  />
                  گزارش تخلف
                </div>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </>
  );
};

export default MessageHeader;
